import { Alert, MapSidebar } from "@landtechnologies/components";
import { useTranslation } from "react-migration/lib";

export const ZoomMessage = () => {
  const { t } = useTranslation();

  return (
    <MapSidebar data-testid="zoom-message">
      <MapSidebar.Body>
        <Alert.Info>
          <span className="atlas-font-bold">{t("comparables.zoom")}</span>
        </Alert.Info>
      </MapSidebar.Body>
    </MapSidebar>
  );
};
